"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var icons_1 = require("../../../icons");
var style_1 = require("../../../style");
var style = react_1.css({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    color: style_1.DesignSystemThemeColor.Gray.LIGHT_1,
    width: 20,
    height: 20,
    margin: -6,
    borderRadius: 3,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    cursor: 'pointer',
    ':enabled:hover': {
        color: style_1.DesignSystemThemeColor.Gray.DEFAULT,
        background: style_1.DesignSystemThemeColor.Gray.LIGHT_4,
    },
    ':enabled:focus': {
        background: '#fff',
        boxShadow: "0px 0px 0px 2px " + style_1.DesignSystemThemeColor.Gray.LIGHT_4,
    },
    ':disabled': {
        cursor: 'not-allowed',
        opacity: 0.5,
    },
});
var ChipClose = function (_a) {
    var onClick = _a.onClick, disabled = _a.disabled;
    return (react_1.jsx("button", { css: style, onClick: function (e) {
            e.stopPropagation();
            onClick();
        }, disabled: disabled },
        react_1.jsx(icons_1.XClose, { size: 14 })));
};
exports.default = ChipClose;
